import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchAndContinue } from 'src/app/lego-utils';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { distinctUntilChanged, filter, switchMap, tap } from 'rxjs/operators';
import { ItemStructure } from 'src/app/models';
import { LegoRestApiDataService } from 'src/app/services';
import { DesignService } from 'src/app/state/design.service';

@Injectable({ providedIn: 'root' })
export class ElementDesignStructureService {
  private readonly structureSubject = new BehaviorSubject<ItemStructure | undefined>(undefined);
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);
  private readonly errorSubject = new BehaviorSubject<string | undefined>(undefined);

  public readonly elementDesignStructure$ = this.structureSubject.asObservable();
  public readonly loading$ = this.loadingSubject.asObservable();
  public readonly error$ = this.errorSubject.asObservable();

  public constructor(
    private readonly designService: DesignService,
    private readonly legoRestApiDataService: LegoRestApiDataService
  ) {
    combineLatest([this.designService.designId$])
      .pipe(
        filter(([designId]) => !!designId),
        distinctUntilChanged(([prev], [curr]) => prev === curr),
        tap(() => {
          this.structureSubject.next(undefined);
          this.errorSubject.next(undefined);
          this.loadingSubject.next(true);
        }),
        switchMap(([designId]) =>
          catchAndContinue(
            this.legoRestApiDataService.getItemStructureById(`ED${designId}`),
            (error) => {
              this.structureSubject.next(undefined);

              if (error instanceof HttpErrorResponse && error.status !== 404) {
                this.errorSubject.next(error.statusText);
              }
            }
          )
        ),
        tap((structure) => {
          this.structureSubject.next(structure);
          this.loadingSubject.next(false);
        })
      )
      .subscribe();
  }
}
